import { ProductsContext } from "Components/GMS/Products/ProductsContext";
import { useISRContext } from "Pages/GMS/ISR/Hooks/useISRContext";
import { ABContext } from "Pages/GMS/ABTesting/contexts/ABContext";
import React, { useContext } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { AppContext } from 'Context/AppContext';

type MenuProps = {
  id: string;
  path: string;
  iconSrc: string;
  filledIconSrc: string;
  label: string;
  matchPath?: string;
  show: boolean;
  menu: object;
  selectedItem: object | null;
  setSelectedItem: React.Dispatch<React.SetStateAction<object | null>>;
}

const MenuItem = ({ id, path, iconSrc, filledIconSrc, label, show, menu, selectedItem, matchPath, setSelectedItem, }: MenuProps) => {
  const isrContext = useISRContext();
  const abContext = useContext(ABContext);
  const appContext = useContext(AppContext);
  const productContext = useContext<any>(ProductsContext);
  const match = useRouteMatch({path: matchPath ? matchPath : path})
  const createPermission = appContext.pm.checkPermission('gmsadministration_create');
  const updatePermission = appContext.pm.checkPermission('gmsadministration_update');

  if (label === 'Manage Parties' && (!updatePermission ||!createPermission)) {
    return null;
  }

  const handleMenuClickEvent = (): void => {
    productContext.setCategoryData([]);
    isrContext?.setPaginationParams({pageNumber: 1, pageSize: 10});
    abContext?.setPaginationParams({pageNumber: 1, pageSize: 10});
  }

  return (
    <li 
      id={id} 
      className={`tw-py-[7px] tw-my-0.5 tw-ps-3 ${
        match
          ? " tw-group tw-bg-[#dee3f6] tw-text-[#030362] tw-rounded-md tw-mx-2"
          : " tw-group hover:tw-bg-[#dee3f6] tw-rounded-md tw-mx-2"
      } `}
    >
      <Link 
        id={`${id}-link`}
        to={path ?? "#"} 
        onClick={handleMenuClickEvent}
        key={label} 
        className={`tw-text-gray-500 tw-font-noto-sans tw-text-xs tw-font-medium tw-leading-normal`}
      >
        <div id={`${id}-content`} className={`tw-flex`}>
          <img 
            id={`${id}-icon`}
            className={`hover:tw-backdrop-hue-rotate-30`} 
            src={match ? filledIconSrc: iconSrc} 
            alt="close" 
            loading="lazy" 
          />
          {show && (
            <span 
              id={`${id}-label`}
              className={`tw-ps-2 ${match ? "tw-text-[#030362]" : "tw-text-gray-500"}`}
            >
              {label}
            </span>
          )}
        </div>
      </Link>
    </li>
  );
};

export default MenuItem;
